import { render, staticRenderFns } from "./SundryCreditorPayments.vue?vue&type=template&id=2f5b3d1c&scoped=true"
import script from "./SundryCreditorPayments.vue?vue&type=script&lang=js"
export * from "./SundryCreditorPayments.vue?vue&type=script&lang=js"
import style0 from "./SundryCreditorPayments.vue?vue&type=style&index=0&id=2f5b3d1c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f5b3d1c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5b3d1c')) {
      api.createRecord('2f5b3d1c', component.options)
    } else {
      api.reload('2f5b3d1c', component.options)
    }
    module.hot.accept("./SundryCreditorPayments.vue?vue&type=template&id=2f5b3d1c&scoped=true", function () {
      api.rerender('2f5b3d1c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sundrycreditor/SundryCreditorPayments.vue"
export default component.exports